import React, { useState } from 'react'
import { Row, Col, Typography, Button, Drawer } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import SubscriptionsTable from 'container/SubscriptionsTable'
import AddSubscriptionForm from 'container/AddSubscriptionForm'

const { Title } = Typography

const SubscriptionsPageLayout: React.FC = () => {
	const [drawerOpen, setDrawerOpen] = useState(false)

	const openDrawer = () => setDrawerOpen(true)
	const closeDrawer = () => setDrawerOpen(false)

	return (
		<>
			<Row justify='space-between' style={{ marginBottom: '1rem' }}>
				<Col>
					<Title level={2}>Subscriptions</Title>
				</Col>
				<Col>
					<Button type='primary' icon={<PlusOutlined />} onClick={openDrawer}>
						Create Plan
					</Button>
				</Col>
			</Row>

			<SubscriptionsTable />

			<Drawer
				title='Create a New Subscription Plan'
				placement='right'
				width='60rem'
				visible={drawerOpen}
				onClose={closeDrawer}
				destroyOnClose
			>
				<AddSubscriptionForm closeDrawer={closeDrawer} />
			</Drawer>
		</>
	)
}

export default SubscriptionsPageLayout
